import React from 'react'
import { useSelector } from "react-redux";

const ArticleRatingPercentage = () => {
  const ratings = useSelector(state => state.articleRatings) || null

  if (ratings && ratings.display_percentage) {
    return (
      <>
        <span className="icon-helped color-grey font-size-xs margin-right-xxs"></span>
        {ratings.likes_percentage} fanden diesen Ratgeber hilfreich
      </>
    );
  }

  return null;
}

export default ArticleRatingPercentage
